import styled from 'styled-components'

import { WebAction, WebHeaderBar } from './styled'

/* QRM-641: the desktop cover. Its own file so the cover ships as one change — the
   shared chrome in ./styled.ts is a separate concern. */

export const CoverScreen = styled.div`
  position: relative;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  background-color: #434343;
  background-image: ${({ theme }) => `url(${theme.backgroundImage})`};
  background-position: center top;
  background-size: cover;
  overflow: hidden;
`

/* the tenant picks the background image, so text legibility cannot be assumed */
export const CoverScrim = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(28, 28, 28, 0.46);
  pointer-events: none;
`

/* the thin part of the "thin cover": logo, the actions, nothing else. Not sticky —
   the cover is one screen with no scroll of its own. */
export const CoverHeader = styled(WebHeaderBar)`
  position: relative;
  z-index: 1;
  background: transparent;
  flex-shrink: 0;
`

export const CoverCenter = styled.div`
  position: relative;
  z-index: 1;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 36px;
  padding: 24px 24px 56px;
`

export const CoverLogo = styled.img`
  width: auto;
  max-width: 440px;
  max-height: 300px;
  object-fit: contain;
`

export const CoverActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;

  /* ButtonsQRM/ButtonsCC are shared with the phone and take no size props (their
     default is 210px) — widen them from here instead of changing their signatures */
  button {
    width: 300px;
    height: 58px;
  }
`

export const CoverNote = styled.div`
  max-width: 560px;
  text-align: center;
`

export const WebActionBadge = styled.span`
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 9px;
  background: #ff0000;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const WebActionWithBadge = styled(WebAction)`
  position: relative;
  overflow: visible;
`
